import Vue from 'vue'

Vue.component('scraper-builder-config', () => import('./config/Builder.vue'))
Vue.component('scraper-builder-environment', () => import('./environment/Builder.vue'))
Vue.component('scraper-builder-system', () => import('./console/Builder.vue'))
Vue.component('scraper-builder-source', () => import('./source/Builder.vue'))